var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ButtonPlain --global-clickable",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"label"},[_vm._v("\n        "+_vm._s(_vm.label)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }